import _ from 'lodash'
import { useCallback, useMemo, useState } from 'react'
import { Link } from 'react-scroll'

import styles from './KlassDetailNav.module.scss'

interface IKlassDetailNavProps {
  handler?: () => void
  isReview?: boolean
  isFaq?: boolean
  isCurriculum?: boolean
}

const GNBHeight = 64
const navbarHeight = 48
const ContentMarginTop = 40

const KlassDetailNav = ({
  handler,
  isFaq,
  isCurriculum,
  isReview = false,
}: IKlassDetailNavProps) => {
  const [activeKey, setActiveKey] = useState('lecture-intro')
  const onChangeKey = useCallback(key => setActiveKey(key), [])

  const navList = useMemo(() => {
    const defaultNav = [
      {
        order: 1,
        label: '강의 소개',
        href: '#lecture-intro',
      },
    ]
    if (isCurriculum) {
      defaultNav.push({
        order: 2,
        label: '커리큘럼',
        href: '#curriculum',
      })
    }
    if (isReview) {
      defaultNav.push({
        order: 3,
        label: '수강후기',
        href: '#review',
      })
    }
    if (isFaq) {
      defaultNav.push({
        order: 4,
        label: '자주 묻는 질문',
        href: '#faq',
      })
    }
    return _.sortBy(_.uniqBy(defaultNav, 'href'), 'order')
  }, [isCurriculum, isFaq, isReview])

  return (
    <div
      className={`sticky z-20 mx-auto box-border max-w-screen-2xl border-b border-gray-200 bg-white ${styles.navContainer}`}>
      <div className="mx-auto max-w-7xl xl:px-6">
        <ul
          className={`flex overflow-x-auto whitespace-nowrap px-4 pt-3 lg:px-6 xl:px-0 ${styles.scrollNo}`}>
          {navList.map(({ label, href }) => {
            const key = href.slice(1)
            const isActive = activeKey === key
            return (
              <li key={key} className={`flex flex-col ${styles.navItem} relative`}>
                <div
                  className={`font-base block cursor-pointer ${
                    isActive ? `${styles.isActiveNav} pb-3 text-primary-normal` : 'text-gray-500'
                  }`}>
                  <Link
                    to={key}
                    spy
                    smooth
                    onClick={() => {
                      if (handler) {
                        handler()
                      }
                    }}
                    onSetActive={() => {
                      onChangeKey(key)
                    }}
                    offset={-(GNBHeight + navbarHeight + ContentMarginTop)}>
                    {label}
                  </Link>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default KlassDetailNav
